import { useEffect, useRef, useState } from 'react';
import { ComboBox, FormControl } from '@airbus/components-react';
import { fieldValidator } from '../../../shared/utils/yupSchemaCreator';
import { applyInclusionFilterOnce, type DropdownOption } from './PPVLeaderUtilities';

export default function PPVLeaderFormField(props: any) {
  const {
    rowId,
    initialValues,
    name,
    label,
    required,
    disabled,
    blurHandler,
    field,
    language,
    options,
    tableRes,
    handleEnterTabBlur,
  } = props;

  const baseOptions: DropdownOption[] = ((options ?? []) as DropdownOption[]).filter(
    (item) => item?.value != null,
  );

  const [valueOptions, setValueOptions] = useState<DropdownOption[]>(baseOptions);
  const [selected, setSelected] = useState<DropdownOption | null>(null);
  const [error, setError] = useState<any>(null);
  const [touched, setTouched] = useState(false);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      await applyInclusionFilterOnce({
        hasFetchedRef,
        htz: initialValues?.htz,
        screenGridId: tableRes?.id,
        baseOptions,
        setValueOptions,
      });
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!initialValues) return;
    const currentValue = initialValues?.[name];

    const valueObj = valueOptions?.find((item) => item.value == currentValue) ?? null;
    setSelected(valueObj);

    let isTouched = false;
    if (
      initialValues?.isCommitRow ||
      (initialValues?.status === 'E' && initialValues?.backup?.[name] !== initialValues[name]) ||
      ((initialValues?.status === 'N' || initialValues?.status === 'C') &&
        initialValues?.touched?.[name])
    ) {
      isTouched = true;
    }
    setTouched(isTouched);
    if (isTouched) {
      const nextErr = fieldValidator(field, currentValue, language);
      setError(nextErr);
    }
  }, [initialValues, name, field, language, valueOptions]);

  const handleChange = (obj: any) => {
    const nextValue = obj?.value ?? null;
    const nextErr = fieldValidator(field, nextValue, language);
    setSelected(obj ?? null);
    setError(nextErr);
  };

  const commitSelected = () => {
    const nextValue = selected?.value ?? null;

    if (field?.onValueChange) {
      const valid = field.onValueChange({
        rowId,
        value: nextValue,
        row: initialValues,
      });
      if (valid === false) {
        const valueObj = valueOptions?.find((item) => item.value == initialValues?.[name]) ?? null;
        setSelected(valueObj);
        return;
      }
    }

    blurHandler(name, nextValue);
  };

  return (
    <FormControl
      {...{ disabled, required, label }}
      id={name}
      error={touched && Boolean(error)}
      errorText={touched && error?.msg}
      className='disabled-input'
    >
      <ComboBox
        {...{ name, disabled }}
        size='small'
        options={valueOptions}
        value={selected}
        getOptionLabel={(option: any) => option.label}
        getOptionValue={(option: any) => option.value}
        onChange={(obj: any) => handleChange(obj)}
        keepInputOnSelect={true}
        allowVirtualization={true}
        onBlur={commitSelected}
        onKeyDown={handleEnterTabBlur}
        hideClear
      />
    </FormControl>
  );
}
